/**
 * Time helpers for the events hub: time-left text (full and the rail's short chip) and the
 * Rush weekend rule the hub's Rush card shows (Friday 00:00 → Monday 00:00 UTC, as the API).
 */
import { weekday } from '@mp/core';
import { t } from '../../i18n/index.js';

const DAY = 86_400_000;

export function leftText(ms: number): string {
  const left = Math.max(0, ms);
  const d = Math.floor(left / DAY);
  const h = Math.floor((left % DAY) / 3_600_000);
  const m = Math.floor((left % 3_600_000) / 60_000);
  const s = Math.floor((left % 60_000) / 1000);
  if (d > 0) return t('feature.events.dh', { d, h });
  if (h > 0) return t('time.hm', { h, m });
  return t('time.ms', { m, s: String(s).padStart(2, '0') });
}

/** "3d" / "5h" / "12m" for the rail chip. */
export function shortLeft(ms: number): string {
  const left = Math.max(0, ms);
  if (left >= DAY) return t('feature.events.leftD', { n: Math.floor(left / DAY) });
  if (left >= 3_600_000) return t('feature.events.leftH', { n: Math.floor(left / 3_600_000) });
  return t('feature.events.leftM', { n: Math.max(1, Math.ceil(left / 60_000)) });
}

/** The running Rush weekend's close, or null Monday to Thursday. */
export function rushClosesAt(now: number): number | null {
  const day = Math.floor(now / DAY);
  const wd = weekday(day);
  return wd < 4 ? null : (day - (wd - 4) + 3) * DAY;
}

/** The next Rush's opening (the coming Friday; during a weekend, the Friday after). */
export function rushOpensAt(now: number): number {
  const day = Math.floor(now / DAY);
  const wd = weekday(day);
  return (day + (wd < 4 ? 4 - wd : 11 - wd)) * DAY;
}
